/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./questioner.vue?vue&type=template&id=27024e21&"
import script from "./questioner.vue?vue&type=script&lang=js&"
export * from "./questioner.vue?vue&type=script&lang=js&"
import style0 from "./questioner.vue?vue&type=style&index=0&id=27024e21&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports